import * as React from 'react';
import './index.css';
import { withTranslation } from '@sailor/i18n-mach-pro';
import { CouponTips, GoodDetailData, GoodDetailMinPrice } from '@/shop/c_shop_golden/component';
import { MultiSkuModel } from '@/shop/shop_multi_sku_modal/component';
import TrackUtils, { EVENT_TYPE } from '../../utils/TrackUtils';

const WMRouter = Mach.requireModule('Router');

interface IProps {
  source: number;
  shopId: string;
  multiSkuModel: MultiSkuModel;
  goodDetailData: GoodDetailData;
  couponTips?: CouponTips;
  originPrice: GoodDetailMinPrice;
  discountPrice: GoodDetailMinPrice;
  onClickToShopPreview?: VoidFunction;

}

class CouponTipsView extends React.Component<IProps, any> {
  constructor(props: IProps) {
    super(props);
  }

  componentDidMount() {
    if (this.props.couponTips?.shopLink) {
      TrackUtils.reportMultiSkuModalEnterShop(
        EVENT_TYPE.MV,
        this.props.multiSkuModel,
        this.props.goodDetailData,
        this.props.shopId,
        this.props.couponTips?.canUserCoupon,
        this.props.source,
        this.props.originPrice?.displayAmount,
        this.props.discountPrice?.displayAmount
      );
    }
  }

  onClickToShopPreview = () => {
    if (this.props.couponTips?.shopLink) {
      TrackUtils.reportMultiSkuModalEnterShop(
        EVENT_TYPE.MC,
        this.props.multiSkuModel,
        this.props.goodDetailData,
        this.props.shopId,
        this.props.couponTips?.canUserCoupon,
        this.props.source,
        this.props.originPrice?.displayAmount,
        this.props.discountPrice?.displayAmount
      );
    }
    WMRouter.navigateTo(this.props.couponTips?.shopLink, {}, (result) => {
      this.props.onClickToShopPreview?.();
    });
  }

  render() {
    // @ts-ignore
    const { t } = this.props;
    const enterShopText = t('landingpage_guige_enter_shop_button');
    return (
      this.props.couponTips?.couponText
            && (
              <view
                className="coupon-tips-container" onClick={() => {
                  //空实现，防止点击事件透传至上层
                }}
              >
                <view
                  className="coupon-tips-container-inner"
                  style={{ justifyContent: this.props.couponTips?.shopLink ? 'space-between' : 'center' }}
                >
                  <text className="coupon-tips-text" content={this.props.couponTips?.couponText} />
                  {this.props.couponTips?.shopLink
                        && (
                          <view
                            className="coupon-tips-enter-shop-container"
                            onClick={() => {
                              this.onClickToShopPreview();
                            }}
                          >
                            <text className="coupon-tips-enter-shop-text" content={enterShopText} />
                          </view>
                        )}
                </view>

              </view>
            )
    );
  }
}

export default withTranslation('', {
  withRef: true,
})(CouponTipsView);
